import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "aria-labelledby"]
const _hoisted_2 = ["id"]

import { DsFormFieldValueType } from "../../models/ds-form-field-models";
import type { Theme } from "../../../types/theme";
import { computed, reactive } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-form-group',
  props: {
    name: {},
    header: {},
    disabled: { type: Boolean },
    theme: {}
  },
  setup(__props: any) {

const props = __props;

const headerId = computed(() => (props.header ? `label-${props.name}` : null));

const itemAttrs = reactive({
    class: "ds-form-group__item",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-form-group", { disabled: _ctx.disabled, 'theme--dark': _ctx.theme === 'dark' }]),
    disabled: _ctx.disabled,
    role: "group",
    "aria-labelledby": headerId.value
  }, [
    (_ctx.header)
      ? (_openBlock(), _createElementBlock("h4", {
          key: 0,
          class: "ds-form-group__header",
          id: headerId.value
        }, _toDisplayString(_ctx.header), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(itemAttrs)))
  ], 10, _hoisted_1))
}
}

})